import { createFileRoute } from '@tanstack/react-router'
import { GuestsSectionPage } from '@/features/setup/guests-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/guests')({
  component: GuestsSectionRoute,
})

function GuestsSectionRoute() {
  const { workspaceSlug } = Route.useParams()

  return <GuestsSectionPage workspaceSlug={workspaceSlug} />
}
